import { AVATAR_SIZES } from '../Constants';
export const getDimensions = size => {
  return {
    width: size !== AVATAR_SIZES.responsive ? AVATAR_SIZES[size] : null,
    height: size !== AVATAR_SIZES.responsive ? AVATAR_SIZES[size] : null
  };
};